var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.253 3.933a1 1 0 0 1 1.414 0l6.4 6.4a1 1 0 0 1-1.344 1.478l-4.763 4.763v1.939a1.5 1.5 0 0 1-.44 1.06l-.78.78a1.5 1.5 0 0 1-2.12 0l-2.78-2.779-3.133 3.133a1 1 0 1 1-1.414-1.414l3.133-3.133-2.78-2.78a1.5 1.5 0 0 1 0-2.12l.78-.78a1.5 1.5 0 0 1 1.061-.44h1.939l4.763-4.763a1 1 0 0 1 .064-1.344M13.6 6.694 8.254 12.04h-2.56l-.28.28 6.266 6.266.28-.28v-2.56l5.346-5.346z",
  clipRule: "evenodd"
})));
export default SvgIcSPin;